export default __webpack_public_path__ + "static/media/photo--sm--misc-21.87c9e041.jpg";